import { borders } from 'src/theme/adSales/borders'

const defaultLink = {
  cursor: 'pointer',
  '&:focus-visible': {
    boxShadow: borders.activeButton
  }
}

const defaultNavigation = {
  textDecoration: 'none',
  display: 'inline-block',
  cursor: 'pointer',
  borderRadius: '0px',
  width: 'auto',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  background: 'background.quaternary',
  px: 3,
  pt: [3, null, null, null, 6],
  pb: [3, null, null, null, 5],
  color: 'text.primary',
  fontWeight: 'medium',
  borderBottom: borders.quaternaryMediumHidden,
  '&:hover': { backgroundColor: 'background.tertiary', borderBottom: borders.tertiaryMediumHidden },
  '&:focus-visible': {
    backgroundColor: 'background.tertiary',
    borderBottom: borders.tertiaryMediumHidden,
    boxShadow: borders.activeButton
  },
  height: '100%'
}

export const links = {
  default: {
    ...defaultLink,
    display: 'block',
    textDecoration: 'none'
  },
  primary: {
    ...defaultLink,
    color: 'text.primary',
    '&:hover': { textDecoration: 'underline' }
  },
  secondary: {
    ...defaultLink,
    color: 'text.secondary',
    textDecoration: 'underline'
  },
  tertiary: {
    ...defaultLink,
    color: 'text.quaternary',
    textDecoration: 'underline'
  },
  quaternary: {
    ...defaultLink,
    color: 'text.primary',
    textDecoration: 'underline',
    '&:hover': { color: 'state.active' }
  },
  navigation: {
    ...defaultNavigation,
    width: ['100%', null, null, null, 'auto'],
    transition: 'background-color 0.4s ease, border-bottom 0.4s ease'
  },
  subNavigation: {
    ...defaultNavigation,
    pl: 4,
    width: '100%',
    fontWeight: 'regular'
  },
  tab: {
    ...defaultNavigation,
    '&:hover': {
      textDecoration: 'underline'
    }
  }
}
